<template>
	<div>
		<v-content>
			<v-container fluid>
              <center><img style="padding-top: 7%;" src="../../shared/assets/images/3dloader.gif" v-if="loaded == false" /></center>
              <v-flex xs3 v-if="loaded == true">
                <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
              </v-flex>
				<v-data-table v-if="loaded == true" :headers="headers" :search="search" ref="sortableTable" :items="rfcStatusList" hide-actions class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">
                        <tr class="sortableRow" id="rows">
                          <td width="5%" class="px-1">
                            <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
                          </td>
						  <td width="65%">{{ props.item.description }}</td>						  
						  <td width="10%" class="text-xs-right">{{ fncCheckBool(props.item.triggers_notification) }}</td>						  
						  <td width="10%" class="text-xs-right"><a @click.prevent="fncEditRfcStatus(props.item.id)"><i class="material-icons">edit</i></a></td>
						  <td width="10%" class="text-xs-right"><a @click.prevent="fncDeleteRfcStatus(props.item.id)"><i class="material-icons">delete_forever</i></a></td>
                        </tr>
					</template>
				</v-data-table>
			</v-container>
		</v-content> 
		<modal></modal>
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';
  import Sortable from 'sortablejs';

  export default {
	name: 'RfcStatusList',
	intRoleEdit: 0,
    data () {
		return {	
			search: '',
            headers: [         
              { text: '', value: 'drag', sortable: false, width: '5%' },
              { text: 'Description', value: 'description', sortable: false, width: '65%' },
              { text: 'Triggers Notification', value: 'triggers_notification', sortable: false, width: '10%' },
              { text: 'Edit', value: 'Edit', sortable: false, width: '10%' },
              { text: 'Delete', value: 'Delete', sortable: false, width: '10%' }
            ],
            loaded: false
		}
	},
	methods: {
		fncEditRfcStatus( statusId ) {
			this.$store.commit({
				type: 'setObjRfcStatusEdit',
				id: statusId
			});
			var modalDetails = { title: 'Edit RFC Status', component: 'modal-rfc-status-edit', mstate: true, params: {statusId: statusId} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
		fncDeleteRfcStatus( statusId ) {
			var deleteConfirm = confirm('Are you sure you want to remove this status?');
			if(deleteConfirm === true) {
				this.$store.dispatch({
					type: 'fncDeleteRfcStatus',
					statusId: statusId
				})
			}
		},
        fncCheckBool( boolId ) {
		   if( boolId === 1 ) {
				return 'Yes';
			} else {
				return 'No';
			}
        },
        fncReorderRfcStatus({ oldIndex, newIndex }) {          
          this.$store.dispatch({
            type: 'fncReorderRfcStatus',
            start: oldIndex,
            end: newIndex
          });
        }
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'rfcStatusList',
			'globalModalParams'
		])
	},
	components: {
		Modal
	},
	beforeMount() {
		this.$store.dispatch('fncPopulateRfcStatusList');
	},
    mounted() {
      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          onUpdate: this.fncReorderRfcStatus
        }
      )
    },
    watch: {
      rfcStatusList() {
        this.loaded = true;
      }
    }
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>